import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const TrainingArchiveTourSteps = [
	{
		selector: '[data-tour="training-page"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingArchive.Welcome">
					Welcome to Training Archive. Search and review past training and drill
					sessions, view KPI statistics, and open session or KPI details.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Tabs">
					Use these tabs to switch between Dashboard, Courses, Drills, Archive,
					and Planner. Dashboard shows the overview here; Courses and Drills
					show detailed session management; Archive lists completed sessions;
					Planner helps schedule training.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-archive-left"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingArchive.Left">
					Search and filters — set a date range and training type (All, Courses,
					Exercises, Events). Use quick range (2m, 6m, 12m) for common periods.
					Switch between Archived Sessions and KPI Statistics tabs to see past
					sessions or KPI data.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-archive-right"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingArchive.Right">
					Session or KPI details — click a session in the list to view its
					details here. For KPI Statistics, click a row to see parameter-level
					statistics. Use this panel to review past performance and drill
					completion.
				</Translate>
			</Box>
		),
	},
];
